'use client'

import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

export const BenefitsBackground = styled(Box)(({ theme }) => ({
  padding: theme.spacing(10, 0, 12.5),
  backgroundColor: theme.palette.grey[100],
}))

export const BenefitsSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(5),
  marginTop: theme.spacing(12.5),
  color: theme.palette.text.secondary,

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',

    '> *': {
      flex: 2,
    },

    '> .image': {
      flex: 1,
    },
  },

  [theme.breakpoints.down('md')]: {
    'img.image': {
      maxWidth: '100%',
      height: 'auto',
    },

    '> *': {
      order: 2,
    },

    '> .image': {
      order: 1,
    },
  },
}))
